import { createStack } from '@famly/mf_layout_stack';
/** Simple wrapper for the dialog's bottom elements */
export const DialogFooter = createStack({ flexDirection: 'column' });
